import { Injectable, inject } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { App } from '@df/core/app';
import { debounceTime, of, switchMap, take } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { filter } from 'rxjs/internal/operators/filter';
import { map } from 'rxjs/internal/operators/map';
import { LoqateService } from '../loqate.service';

@Injectable({
    providedIn: 'root'
})
export class LoqateEmailValidatorService {
    protected app = inject(App);
    protected loqateService = inject(LoqateService);

    validatorFunction(control: AbstractControl): Observable<ValidationErrors | null> {
        if (!control.value?.length || !this.loqateService.isEnabled) {
            return of(null);
        }

        return control.valueChanges.pipe(
            debounceTime(500),
            take(1),
            switchMap(value => this.loqateService.validateEmail(value)),
            filter(items => !!items),
            map(items => this.loqateService.getEmailError(items, control.value))
        );
    }

    validate(control: AbstractControl): Observable<ValidationErrors | null> {
        return this.validatorFunction(control);
    }
}
